import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import { AuthProvider } from "./context/AuthContext";
import { ToastProvider } from "./context/ToastContext";
import { OrderNotificationsProvider } from "./context/OrderNotificationsContext";
import { ReturnsNotificationsProvider } from "./context/ReturnsNotificationsContext";
import ScrollToTop from "./ScrollToTop";

const App = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />  {/* ← Add this line */}
      <ToastProvider>
        <AuthProvider>
          <OrderNotificationsProvider>
            <ReturnsNotificationsProvider>
              <AppRoutes />
            </ReturnsNotificationsProvider>
          </OrderNotificationsProvider>
        </AuthProvider>
      </ToastProvider>
    </BrowserRouter>
  );
};

export default App;
